import downloadIcon from "../../Resources/Image/sd-download.svg"

const csvRowHeader = ["Company Name", "Admin Name", "Admin Email", "Phone Number", "Country", "Current Plan", "Total Orders", "Total Paid Orders", "Total Amount($)", "Discount Amount($)", "Total Payable Amount($)"];

export const escapeCsvCell = (value) => {
    if (value == null) {
        return "";
    }

    const stringValue = String(value);
    if (/[",\r\n]/.test(stringValue)) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }

    return stringValue;
};

const formatCsvRow = (cells) => cells.map(escapeCsvCell).join(",");

export const getUsageCSVDataLink = (fileName, paymentData, accountData) => {
    fileName += ".csv";
    let blob = new Blob([createCSVRows(paymentData, accountData)], {type: "text/csv"});
    let url = window.URL.createObjectURL(blob);
    return <a className="downloadBtn" href={url} download={fileName} title={"Download Details"}><img
        src={downloadIcon}/></a>;
}

const createCSVRows = (paymentData, accountData) => {
    let rowString = formatCsvRow(csvRowHeader);
    rowString += "\n";
    paymentData.map((entry) => {
        let accountDetails = accountData[entry.companyId] ?? {};
        let discountAmount = (entry.discountAmount ?? 0).toFixed(2);
        let paymentAfterDiscount = (entry.billableAmount - (entry.discountAmount ?? 0)).toFixed(2);
        let row = [
            accountDetails.companyName ?? "",
            accountDetails.adminName ?? "",
            accountDetails.email ?? "",
            accountDetails.phoneNumber ?? "",
            accountDetails.country ?? "",
            accountDetails.currentPlan ?? "",
            entry.numberOfOrders,
            entry.numberOfPaidOrders,
            entry.billableAmount,
            discountAmount,
            paymentAfterDiscount,
        ];
        rowString += formatCsvRow(row) + "\r\n";
    })
    return rowString;
}
